import * as Sentry from "@sentry/nextjs";
import { sentryOptions } from "./sentry.config";

Sentry.init(sentryOptions as Parameters<typeof Sentry.init>[0]);
